import { buildAIPrompt, SYMPTOM_NAMES } from './aiPromptTemplate';
/**
 * Build context summary from sleep survey answers
 */
export function buildContextFromAnswers(answers) {
  const contextParts = [];

  if (answers.safety) {
    if (answers.safety.includes('none')) {
      contextParts.push('- Good health condition, no specific risks');
    } else {
      contextParts.push('- Some health concerns to note');
    }
  }

  if (answers.demographics) {
    const age = answers.demographics.age;
    const weight = answers.demographics.weight;
    if (age) contextParts.push(`- Age group: ${age}`);
    if (weight) contextParts.push(`- Weight: ${weight}`);
  }

  if (answers.mainIssue) {
    const issues = answers.mainIssue.map(issue => {
      switch (issue) {
        case 'difficulty_falling': return 'Difficulty falling asleep';
        case 'light_sleep': return 'Light sleep';
        case 'early_wake': return 'Early awakening';
        case 'poor_quality': return 'Poor sleep quality';
        default: return issue;
      }
    });
    contextParts.push(`- Main concerns: ${issues.join(', ')}`);
  }

  if (answers.timeToSleep) {
    const timeMap = {
      '30-60min': 'Takes 30 mins to 1 hour to fall asleep',
      '1-2hr': 'Takes 1-2 hours to fall asleep',
      '>2hr': 'Takes over 2 hours to fall asleep'
    };
    contextParts.push(`- ${timeMap[answers.timeToSleep]}`);
  }

  if (answers.wakeTimes) {
    const wakeMap = {
      '1-2': 'Wakes up 1-2 times per night',
      '3-4': 'Wakes up 3-4 times per night',
      'many': 'Wakes up many times'
    };
    contextParts.push(`- ${wakeMap[answers.wakeTimes]}`);
  }

  if (answers.fallingFeeling) {
    const feelingMap = {
      'racing_thoughts': 'Racing thoughts when falling asleep',
      'tired_cant_sleep': 'Physically tired but cannot sleep',
      'anxious': 'Anxious, fast heartbeat',
      'no_feeling': 'No specific discomfort but cannot sleep'
    };
    contextParts.push(`- ${feelingMap[answers.fallingFeeling]}`);
  }

  if (answers.wakeFeeling) {
    const feelingMap = {
      'racing_thoughts': 'Mind is alert when waking up at night',
      'anxious': 'Fast heartbeat/sweating when waking up',
      'no_feeling': 'No specific feeling when waking up'
    };
    contextParts.push(`- ${feelingMap[answers.wakeFeeling]}`);
  }

  if (answers.duration) {
    const durationMap = {
      '<1month': 'Started within the last month',
      '1-3months': 'Has lasted 1-3 months',
      '>3months': 'Over 3 months (chronic insomnia)'
    };
    contextParts.push(`- Duration: ${durationMap[answers.duration]}`);
  }

  if (answers.frequency) {
    const freqMap = {
      '1-2': '1-2 times per week',
      '3-4': '3-4 times per week',
      '5+': 'Almost every day'
    };
    contextParts.push(`- Frequency: ${freqMap[answers.frequency]}`);
  }

  return contextParts.join('\n');
}

/**
 * Build prompt for sleep questions
 */
export function buildPrompt(question, answers, userName) {
  const context = buildContextFromAnswers(answers);
  return buildAIPrompt(SYMPTOM_NAMES.sleep, context, question.text, userName);
}